import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

export const UNSAVED_CHANGES_MODAL_TEST_ID = 'unsaved-changes-modal';
export const UNSAVED_CHANGES_MODAL_SAVE_BUTTON_TEST_ID = 'unsaved-changes-modal-save-button';
export const UNSAVED_CHANGES_MODAL_DISCARD_BUTTON_TEST_ID = 'unsaved-changes-modal-discard-button';

export type UnsavedChangesModalProps = {
  onClose: () => void;
  onLeave: () => void;
  onSave: () => void;
};

export const UnsavedChangesModal = ({ onClose, onLeave, onSave }: UnsavedChangesModalProps) => {
  return (
    <Modal
      id="unsavedChangesModal"
      isModalOpen={true}
      onClose={onClose}
      data-test={UNSAVED_CHANGES_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>Unsaved changes</ModalHeader>
      <ModalBody>
        This campaign&apos;s template has been edited. Do you want to save your changes?
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={onLeave}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
          data-test={UNSAVED_CHANGES_MODAL_DISCARD_BUTTON_TEST_ID}
        >
          Leave without saving
        </Button>
        <Button
          onClick={onSave}
          size={BUTTON_SIZES.LARGE}
          data-test={UNSAVED_CHANGES_MODAL_SAVE_BUTTON_TEST_ID}
        >
          Save and exit
        </Button>
      </ModalFooter>
    </Modal>
  );
};
